import React from 'react';
import '../admin/Admin.css';
import '../auth/Auth.css';

const PlanCard = ({
  title,
  priceText,
  subtitle,
  features = [],
  isCurrent = false,
  variant = 'default', // 'default' | 'pro'
  tokenPricing = null, // React node shown above CTA (e.g., token pricing list)
  ctaLabel,
  ctaDisabled = false,
  onCtaClick,
  ariaLabel,
  ctaNote
}) => {
  const variantClass = variant === 'pro' ? 'plan-card pro' : 'plan-card';
  const titleId = `plan-title-${(title||'').toString().toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
  const ctaNoteId = ctaNote ? `${titleId}-note` : undefined;
  return (
    <div className={variantClass} role="region" aria-label={`${title} plan`} aria-labelledby={titleId}>
      {isCurrent && (
        <div className="plan-badge" aria-label="Current plan">Current plan</div>
      )}
      <h3 id={titleId} className="plan-title">{title}</h3>
      {priceText && (<div className="plan-price">{priceText}</div>)}
      {subtitle && (<div className="plan-subtitle">{subtitle}</div>)}
      {features.length > 0 && (
        <ul className="plan-features">
          {features.map((f, idx) => (<li key={idx}>{f}</li>))}
        </ul>
      )}
      {tokenPricing}
      {ctaLabel && (
        <div className="plan-cta">
          <button
            className="action-button primary small"
            onClick={onCtaClick}
            disabled={ctaDisabled}
            aria-label={ariaLabel || ctaLabel}
            aria-describedby={ctaDisabled && ctaNoteId ? ctaNoteId : undefined}
            title={ctaDisabled ? 'Stripe checkout coming soon' : undefined}
          >
            {ctaLabel}
          </button>
          {ctaNote && (<div id={ctaNoteId} className="plan-cta-note">{ctaNote}</div>)}
        </div>
      )}
    </div>
  );
};

export default PlanCard;


